<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <v-card
    class="mt-1"
    elevation="0"
  >
    <v-card-text>
      <div class="d-flex align-center justify-center">
        <div>{{ $t('totalRound') }}</div>
        <v-spacer />
        <div>{{ info.totalRound }}</div>
      </div>
      <div class="d-flex align-center justify-center">
        <div>{{ $t('roundTime') }}</div>
        <v-spacer />
        <div>{{ info.roundTime }}</div>
      </div>
      <div class="d-flex align-center justify-center">
        <div>{{ $t('maxDineTime') }}</div>
        <v-spacer />
        <div>{{ info.maxDineTime }}</div>
      </div>
      <div class="d-flex align-center justify-center">
        <div>{{ $t('roundDishCount') }}</div>
        <v-spacer />
        <div>{{ info.roundDishCount }}</div>
      </div>
      <div class="d-flex align-center justify-center">
        <div>{{ $t('childRoundDishCount') }}</div>
        <v-spacer />
        <div>{{ info.childRoundDishCount }}</div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>

import BuffetSetting from '@/model/dataLayer/api/buffet/BuffetSetting'

const DefaultMenuInfo = {
  consumeTypeId: '',
  totalRound: '',
  roundDishCount: '',
  childRoundDishCount: '',
  maxDineTime: '',
  roundTime: ''
}
export default {
  name: 'MenuInfoBlock',
  data: function () {
    return {
      consumeTypeInfo: {}
    }
  },
  props: {
    menuInfo: {
      type: Object,
      default: () => DefaultMenuInfo
    }
  },
  // data: function () {
  //   return Object.assign({}, DefaultMenuInfo, this.addressInfo)
  // },
  computed: {
    info () {
      const propsInfo = Object.assign({}, DefaultMenuInfo, this.menuInfo)
      propsInfo.roundTime = parseFloat(propsInfo.roundTime) / 60
      propsInfo.maxDineTime = parseFloat(propsInfo.maxDineTime) / 60
      return Object.assign({}, DefaultMenuInfo, this.consumeTypeInfo, propsInfo)
    }
  },
  async mounted () {
    this.consumeTypeInfo = (await BuffetSetting.getList(true)).find(it => it?.consumeTypeId === this.menuInfo?.consumeTypeId)
  }
}
</script>

<style scoped>

</style>
